import { render, staticRenderFns } from "./PrestaPush.vue?vue&type=template&id=9e160c70&scoped=true"
import script from "./PrestaPush.vue?vue&type=script&lang=js"
export * from "./PrestaPush.vue?vue&type=script&lang=js"
import style0 from "./PrestaPush.vue?vue&type=style&index=0&id=9e160c70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e160c70",
  null
  
)

export default component.exports